import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const item = event.target.closest(".faq-item")
    item.classList.toggle("open")
  }
}
